<template>
	<div>
		<el-option v-for="data in datas" :label="data.valueTitle" :value="data.value"></el-option>
	</div>
</template>
<script>
	export default {
		name: 'subSelect',
		props: ['businessName'],
		data() {
			return {
				"datas":[]
			};
		},
		methods: {
			handleQuery() { //查询
				let that= this;
				this.$http({
					method: 'POST',
					url: 'cm/dictionaries/queryByBusinessName',
					data: {
						"businessName":this.businessName
					},
				}).then(function(res) {
					if (res.data.errorCode == '0000') {
						that.datas=res.data.data;
					}
				})
			}
		},
		mounted:function()  {
			this.handleQuery();
		}

	}
</script>



// WEBPACK FOOTER //
// src/components/layout/sub-select.vue